import React from 'react';

// Coordinates follow the actual nail image, including narrow/short shapes.
// Soft studio reflections keep an opaque gel legible without adding texture.
export default function SolidGelGloss({bounds,prefix}) {
 return <g data-solid-gel-gloss="true" pointerEvents="none" transform={`translate(${bounds.x} ${bounds.y}) scale(${bounds.width/100} ${bounds.height/150})`} fill="none" stroke="white" strokeLinecap="round">
  <defs>
   <linearGradient id={`${prefix}solidReflection`} x1="0" y1="0" x2="0" y2="1"><stop stopColor="white" stopOpacity=".7"/><stop offset=".42" stopColor="white" stopOpacity=".4"/><stop offset="1" stopColor="white" stopOpacity="0"/></linearGradient>
   <filter id={`${prefix}solidSoft`} x="-70%" y="-20%" width="240%" height="140%"><feGaussianBlur stdDeviation="1.1"/></filter>
  </defs>
  <path d="M31 17C24 39 24 77 28 105C30 120 35 132 42 140" stroke={`url(#${prefix}solidReflection)`} strokeWidth="7" opacity=".48" filter={`url(#${prefix}solidSoft)`}/>
  <path d="M29 22C27 30 26 38 26 45" strokeWidth="2.5" opacity=".73"/>
  <path d="M26 53L26 61" strokeWidth="2" opacity=".48"/>
  <path d="M73 30C77 42 78 55 76 66" strokeWidth="4" opacity=".4" filter={`url(#${prefix}solidSoft)`}/>
  <path d="M74 35C77 47 77 52 76 57" strokeWidth="2.1" opacity=".74"/>
  <path d="M76 80C76 102 68 126 56 142" strokeWidth="1.9" opacity=".45"/>
 </g>;
}
